import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 24 24" {...props}>
    <polygon
      fill="#231F20"
      points="13.959,7.25 13.959,8.25 18.354,8.25 18.354,20.959 5.646,20.959 5.646,8.25 10.042,8.25
        10.042,7.25 4.646,7.25 4.646,21.959 19.354,21.959 19.354,7.25 "
    />
    <polygon
      fill="#231F20"
      points="11.98,1.23 8.646,4.563 9.354,5.271 11.5,3.124 11.5,3.185 11.5,13.875 12.5,13.875 12.5,3.185
        12.5,3.124 14.646,5.271 15.354,4.563 "
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/ShareIos7.jsx